module.exports = __webpack_public_path__ + "img/cnd_Global.07ff8a44.svg";